import React, { useContext, useEffect } from "react";

import {
  Grid,
  Paper,
  Avatar,
  Typography,
  Divider,
  Box,
  CircularProgress,
} from "@material-ui/core";

import PeopleIcon from "@material-ui/icons/People";
import PersonIcon from "@material-ui/icons/Person";
import TranslateIcon from "@material-ui/icons/Translate";
import DescriptionIcon from "@material-ui/icons/Description";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import WarningIcon from "@material-ui/icons/Warning";
import EventIcon from "@material-ui/icons/Event";
import CakeIcon from "@material-ui/icons/Cake";

import { DashboardContext } from "../../../context/states/dashboardState";
import { useStyles } from "./styles";

const InterpreterDashboard = () => {
  const classes = useStyles();

  const {
    getInterpreterDashboardHandler,
    interpreterDashboard,
    interpreterDashboardLoading,
  } = useContext(DashboardContext);

  useEffect(() => {
    getInterpreterDashboardHandler();
  }, []);

  const overviewCards = [
    {
      name: "Total Interpreters",
      count: interpreterDashboard?.totalInterpreters || 0,
      icon: <PeopleIcon />,
      className: "total",
    },
    {
      name: "Active Interpreters",
      count: interpreterDashboard?.totalActiveInterpreters || 0,
      icon: <PersonIcon />,
      className: "active",
    },
    {
      name: "Translators",
      count: interpreterDashboard?.totalTranslators || 0,
      icon: <TranslateIcon />,
      className: "translator",
    },
    {
      name: "Transcribers",
      count: interpreterDashboard?.totalTranscribers || 0,
      icon: <DescriptionIcon />,
      className: "transcriber",
    },
    {
      name: "Interpreters",
      count: interpreterDashboard?.totalInterpretersService || 0,
      icon: <RecordVoiceOverIcon />,
      className: "interpreter",
    },
  ];

  const expiryCards = [
    {
      name: "DBS Expired Active Interpreters",
      count: interpreterDashboard?.dbsExpiredActiveInterpreters || 0,
      icon: <WarningIcon />,
      className: "danger",
    },
    {
      name: "Passport Expired Active Interpreters",
      count: interpreterDashboard?.passportExpiredActiveInterpreters || 0,
      icon: <WarningIcon />,
      className: "danger",
    },
    {
      name: "DBS Expiring in 30 Days",
      count: interpreterDashboard?.dbsExpiringIn30Days || 0,
      icon: <EventIcon />,
      className: "warning",
    },
    {
      name: "Passport Expiring in 30 Days",
      count: interpreterDashboard?.passportExpiringIn30Days || 0,
      icon: <EventIcon />,
      className: "warning",
    },
  ];

  if (interpreterDashboardLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="300px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={1}>
      {/* =========================================
          INTERPRETER OVERVIEW
      ========================================== */}

      <Grid item xs={12}>
        <Typography variant="h6">Interpreter Overview</Typography>
      </Grid>

      {overviewCards.map((card, index) => (
        <Grid item xs={12} sm={6} md={2} key={index}>
          <Paper elevation={1} className={classes.paper}>
            <div className={classes.nameDiv}>
              <Typography variant="h6">{card.name}</Typography>

              <Typography variant="h4" gutterBottom className={classes.count}>
                {card.count}
              </Typography>
            </div>

            <Avatar className={classes[card.className]}>{card.icon}</Avatar>
          </Paper>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Divider />
      </Grid>

      {/* =========================================
          DOCUMENT EXPIRY
      ========================================== */}

      <Grid item xs={12}>
        <Typography variant="h6">Document Expiry Alerts</Typography>
      </Grid>

      {expiryCards.map((card, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Paper elevation={1} className={classes.paper}>
            <div className={classes.nameDiv}>
              <Typography variant="h6">{card.name}</Typography>

              <Typography variant="h4" gutterBottom className={classes.count}>
                {card.count}
              </Typography>
            </div>

            <Avatar className={classes[card.className]}>{card.icon}</Avatar>
          </Paper>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Divider />
      </Grid>

      {/* =========================================
          TODAY'S BIRTHDAYS
      ========================================== */}

      <Grid item xs={12}>
        <Paper elevation={1} className={classes.birthday}>
          <Box p={2}>
            <Box display="flex" alignItems="center" mb={2}>
              <Avatar className={classes.birthdayAvatar}>
                <CakeIcon />
              </Avatar>

              <Box ml={2}>
                <Typography variant="h6">Today's Birthdays</Typography>
              </Box>
            </Box>

            {interpreterDashboard?.todaysBirthdays?.length > 0 ? (
              <Grid container spacing={2}>
                {interpreterDashboard.todaysBirthdays.map((interpreter) => (
                  <Grid item xs={12} sm={6} md={4} key={interpreter._id}>
                    <Box display="flex" alignItems="center">
                      <Avatar>
                        {interpreter?.fname?.charAt(0)?.toUpperCase() || "I"}
                      </Avatar>

                      <Box ml={2}>
                        <Typography variant="subtitle1">
                          {interpreter.fullname ||
                            `${interpreter.fname || ""} ${
                              interpreter.lname || ""
                            }`}
                        </Typography>

                        <Typography variant="body2" color="textSecondary">
                          {interpreter.int_id}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Typography variant="body2" color="textSecondary">
                No interpreter birthdays today.
              </Typography>
            )}
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default InterpreterDashboard;
